export enum ActionType {
  REVIEW_PRODUCT = 'ecommerce/REVIEW_PRODUCT',
  ADD_PRODUCT_TO_CART = 'ecommerce/ADD_PRODUCT_TO_CART',
  REMOVE_PRODUCT_FROM_CART = 'ecommerce/REMOVE_PRODUCT_FROM_CART',
  PURCHASE_PRODUCTS = 'ecommerce/PURCHASE_PRODUCTS'
}